<template>
  <footer class="footer bg-gradient-secondary">
    <div class="container">
      <hr />
      <div class="row align-items-center justify-content-md-between">
        <div class="col-md-9">
          <div>
            Written by @Dodecane2242 for the Hedera21 - Hello Tokenization
            Hackathon
          </div>
        </div>
        <div class="col-md-3">
          <ul class="nav nav-footer justify-content-end">
            <a
              target="_blank"
              rel="noopener"
              href="https://twitter.com/Dodecane2242"
              class="btn btn-neutral btn-icon-only btn-twitter btn-round btn-lg"
              data-toggle="tooltip"
              data-original-title="Follow us"
            >
              <i class="fa fa-twitter"></i>
            </a>
            <a
              target="_blank"
              rel="noopener"
              href="https://github.com/Dodecane/hedera-wallet-playground"
              class="btn btn-neutral btn-icon-only btn-github btn-round btn-lg"
              data-toggle="tooltip"
              data-original-title="Star on Github"
            >
              <i class="fa fa-github"></i>
            </a>
          </ul>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  name: "app-footer",
};
</script>
<style></style>
